<template>
<div
  class="wallet-workpackage font-weight-light"
  :style="
  selected?`
  position: fixed;
  padding: 10px 0px 10px 0px;
  top: ${$vuetify.breakpoint.smAndDown?'30px':'78px'};
  z-index: 1;
  width: ${!$vuetify.breakpoint.smAndDown?
    'calc((100vw - 50px) / 3 - 20px)':
    'calc(100vw - 20px)'
  }
  `:`
  z-index: 0;
  width: ${!$vuetify.breakpoint.smAndDown?
    'calc((100vw - 50px) / 3 - 20px)':
    'calc(100vw - 20px)'
  }
  `
  "
  >
  <div :class="`wallet-workpackage-header-slot${selected}${other_selected}`">
    <slot
      name="header"
      :twork_package="twork_package"
      :previous_twork_package="previous_twork_package"
      />
  </div>
  <div :class="`wallet-workpackage-body-slot${selected}${other_selected}`">
    <slot name="body" :twork_package="twork_package"/>
  </div>
</div>
</template>
<script>
export default {
  props: ['twork_package', 'previous_twork_package', 'selected', 'other_selected'],
  data: () => ({

  }),
  methods: {
  }
}
</script>
<style>
.wallet-workpackage {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc((100vw - 50px) / 3 - 20px);
  justify-content: center;
  align-items: center;
  font-size: 16px;
  user-select: none;
  /* z-index: 3; */
  margin-top: -3px;
  top: 0px;
}
/* .wallet-workpackage-selected {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  user-select: none;
  z-index: 2;

  padding: 10px;
  position: relative;
  top: calc(-100vh + 200px);
  transition: all 0.2s ease-in-out
} */

.wallet-workpackage-body-slot {
  position: relative;
  width: 100%;
}
.wallet-workpackage-body-slot-selected {
  position: relative;
  width: 100%;
}

/* header normal */
.wallet-workpackage-header-slot {
  width: 100%;
  margin-bottom: -36px;
  transition: margin 0.2s ease-in-out;
}
.wallet-workpackage-header-slot:hover {
  margin-top: -20px;
  margin-bottom: -16px;
}

/* header seleceted */
.wallet-workpackage-header-slot-selected {
  width: 100%;
  /* margin-top: -20px;
  margin-bottom: -16px; */
}

/* header other selected */
.wallet-workpackage-header-slot-other-selected {
  width: 100%;
  margin-top: -40px;
  margin-bottom: -28px;
  transition: margin 0.2s ease-in-out;
}
/* .wallet-workpackage-header-slot-other-selected:hover {
  width: 100%;
  margin-top: -20px;
  margin-bottom: -40px;
} */
</style>
